import { TransitionKind } from "@repo/api/transition";
import {
  getDefaultDurationInFrames,
  getDefaultPreviewClipDurationsInFrames,
  getDefaultTiming,
  ImageTransitionBuilder,
} from "./ImageTransitionBuilder.ts";
import { splitReveal, SplitRevealProps } from "./SplitRevealPresentation.tsx";

const transitionKind = TransitionKind.enum.SPLIT_REVEAL;

export const ImageSplitRevealTransitionBuilder: ImageTransitionBuilder<SplitRevealProps> =
  {
    formConfig: {
      kind: transitionKind,
      buildDefaultValue: () => ({ kind: transitionKind, speed: "NORMAL" }),
      speed: ["SLOW", "NORMAL", "FAST"],
    },

    transition: {
      getDurationInFrames: getDefaultDurationInFrames,
      buildPresentation: () => splitReveal(),
      buildTiming: getDefaultTiming,
    },

    getPreviewClipDurationsInFrames: getDefaultPreviewClipDurationsInFrames,
  };
